<form [formGroup]="configForm" id="config-form" class="dkuform-modal-horizontal">
    <div class="control-group">
        <label class="control-label">
            Variable
        </label>
        <div class="controls">
            <single-variable-selector [variables]="allVariables$ | async" formControlName="column"></single-variable-selector>
        </div>
    </div>  
</form>